import gql from 'graphql-tag';

const ASSET_FRAGMENT = gql`
  fragment BaseAsset on Asset {
    id
    title
    description
    locale
    data
    filename
    fileType
    url
  }
`;
export default ASSET_FRAGMENT;
